module.exports = __webpack_public_path__ + "static/media/plus-in-circle.fcd79cdf.svg";